import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
        en: {
            translations: {
                'General': 'General',
                'Dashboards,Widgets': 'Dashboards,Widgets',
                'Dashboard': 'Dashboard',
                'Default': 'Default',
                'Ecommerce': 'Ecommerce',
                'Widgets': 'Widgets',
                'Chart': 'Chart',
                'Applications': 'Applications',
                'Ready to use Apps': 'Ready to use Apps',
                
                'Overview': 'Overview',
                'Process': 'Process',
                'Applications_menu': 'Applications',
                'Benefits': 'Benefits',
                'Files': 'Files',
                'Activities': 'Activities',
                
                'Overview_Title': 'Overview — Circular Carbon Project',
                'Creation_Date': 'Creation Date',
                'Due_Date': 'Due Date',
                'Priority': 'Priority',
                'High': 'High',
                'Status': 'Status',
                'In_Progress': 'In Progress',
                'Resource': 'Resource',
                'Technical_Report': 'Technical Report "Carbon Flow — WebFlow Project"',
                
                'Professors_Participants': 'Professors and Participants',
                
                'CO2_Title': 'Carbon Dioxide: Energy, Climate and Sustainable Innovation',
                'CO2_Summary': 'Carbon dioxide (CO₂) is one of the most present gases in our daily lives — essential for life, but also the protagonist of discussions about climate change. Understanding its cycle, uses and impacts is the first step to transform challenges into future solutions.',
                'CO2_Description1': 'From the energy sector to the food industry, CO₂ is everywhere: refrigeration, welding, beverages, controlled agriculture and even in capture and storage technologies that promise to redefine the green economy.',
                'CO2_Description2': 'Follow the data below and discover how carbon dioxide behaves in volume, emissions and average profitability in major production chains.',
                
                'AI_Prediction_Title': 'AI for CO₂ Emissions Prediction',
                'AI_Prediction_Description': 'How Artificial Intelligence can be a powerful tool to predict CO₂ emissions.',
                'Explore': 'Explore',
                
                'Average_Daily_Sales': 'Average Daily Sales',
                'Average_Daily_Sales_Value': '45,908 kg of CO₂',
                'Average_Daily_Sales_Subtitle': 'The increase is due to the expansion of industrial applications and greater demand for liquid CO₂ for refrigeration and beverages.',
                
                'Average_Daily_Profitability': 'Average Daily Profitability',
                'Average_Daily_Profitability_Value': '89.6% energy efficiency',
                'Average_Daily_Profitability_Subtitle': 'The indicator reflects efficiency in conversion and reuse of gas in capture and reuse processes.',
                
                'Activity_Schedule': 'Activity Schedule',
                'Industrial_Emissions_Monitoring': 'Industrial emissions monitoring',
                'Workshop_New_Technologies': 'Workshop: New Carbon Capture Technologies',
                
                'CO2_Emissions_Evolution': 'Evolution of CO₂ Emissions by Sector (Jan–Nov)',
                'Energy': 'Energy',
                'Transport': 'Transport',
                'Industry': 'Industry',
                'CO2_Chart_Description': 'The data shows stability in average industry emissions and a slight decline in the energy sector, a direct result of increased use of biogas and solar energy.',
                
                'CO2_Captured': 'CO₂ Captured',
                'CO2_Reused': 'CO₂ Reused',
                'CO2_Emitted': 'CO₂ Emitted',
                
                'CO2_Emissions_Evolution_Value': 'Evolution of CO₂ Emissions by Value (Jun - December 2024)',
                
                'WAG_Process': 'WAG Process',
                'WAG_Process_Description': 'The WAG process involves alternating water and gas injection to maximize oil recovery',
                'Water_Injection': 'Water injection to maintain reservoir pressure',
                'Gas_Injection': 'Gas injection to improve oil mobility',
                'Continuous_Monitoring': 'Continuous monitoring of production parameters',
                'Field_Based_Optimization': 'Field-based optimization',
                
                'WAG_Applications': 'WAG Applications',
                'WAG_Applications_Description': 'WAG is applied to various types of reservoirs',
                'High_Viscosity_Reservoirs': 'High viscosity oil reservoirs',
                'Mature_Fields': 'Mature fields with production decline',
                'Heterogeneous_Reservoirs': 'Reservoirs with permeability heterogeneity',
                'Offshore_Onshore': 'Offshore and onshore fields',
                
                'WAG_Benefits': 'WAG Benefits',
                'WAG_Benefits_Description': 'Main advantages of the WAG technique',
                'Recovery_Increase': 'Recovery Increase',
                'Recovery_Description': 'Increase in oil recovery',
                'Energy_Efficiency': 'Energy Efficiency',
                'Energy_Description': 'Reduction in energy consumption',
                'Cost_Benefit': 'Cost-Benefit',
                'Cost_Description': 'Improvement in cost-benefit ratio',
                
                'Documents_Attachments': 'Documents and Attachments',
                'Documents_Description': 'Technical documentation and reports related to WAG',
                'Field_Reports': 'Field reports',
                'Laboratory_Analysis': 'Laboratory analysis',
                'Technical_Documentation': 'Technical documentation',
                'Certifications_Licenses': 'Certifications and licenses',
                
                'Recent_Activities': 'Recent Activities',
                'Recent_Activities_Description': 'Latest project activities and updates',
                'Activities_Today': 'Activities Today',
                'Completed_Tasks': 'Completed tasks',
                'This_Week': 'This Week',
                'Activities_Performed': 'Activities performed',
                'Progress': 'Progress',
                'Project_Completion': 'Project completion',
                
                'Content_Not_Found': 'Content not found',
                
                'Menu_EOR': 'EOR',
                'Menu_EOR_Desc': 'Enhanced Oil Recovery',
                'Menu_WAG': 'WAG',
                'Menu_CO2_Injection': 'CO₂ Injection',
                'Menu_HO2_Injection': 'HO₂ Injection',
                
                'Menu_CCUS': 'CCUS',
                'Menu_CCUS_Desc': 'Carbon Capture, Utilization and Storage',
                'Menu_CCS': 'CCS',
                'Menu_Storage_Site_Assessment': 'Storage Site Assessment',
                'Menu_Geological_Reservoirs': 'Geological Reservoirs',
                'Menu_Depleted_Oil_Wells': 'Depleted Oil Wells Onshore/Offshore',
                'Menu_Salt_Caverns': 'Salt Caverns',
                'Menu_Basalt_Others': 'Basalt and Others',
                'Menu_Products': 'Products',
                'Menu_Alternative_Materials': 'Alternative Materials',
                
                'Menu_Renewable_Energy': 'Renewable Energy',
                'Menu_Renewable_Energy_Desc': 'Sustainable Energy Sources',
                'Menu_Hydrogen': 'Hydrogen',
                'Menu_Bioenergy': 'Bioenergy',
                'Menu_Metocean': 'Metocean',
                
                'Menu_Advanced_Materials': 'Advanced Materials',
                'Menu_Advanced_Materials_Desc': 'Innovative Materials Technologies',
                'Menu_MOF': 'MOF (Metal-Organic Frameworks)',
                'Menu_Solar_Cells': 'Solar Cells',
                'Menu_Graphene_Batteries': 'Graphene in Batteries/Membranes',
                'Menu_Nanocells': 'Nanocells',
                
                'Menu_Carbon_Credits': 'Carbon Offset Credits',
                'Menu_Carbon_Credits_Desc': 'Carbon Market and Sustainability',
                'Menu_CO2_Quantification': 'CO₂ Quantification',
                'Menu_Market_Analysis': 'Market Analysis',
                'Menu_Nature_Preservation': 'Nature Preservation',
                'Menu_Reforestation': 'Reforestation',
                
                'Menu_Electrification': 'Electrification',
                'Menu_Electrification_Desc': 'Power Generation Technologies',
                'Menu_Nuclear_Reactors': 'Nuclear Reactors',
                'Menu_Underwater_Facilities': 'Underwater Facilities',
                
                'Profile_Articles': 'Articles',
                'Profile_Presentations': 'Presentations',
                'Profile_Reviews': 'Reviews'
            }
        },
            cn: {
                translations: {
                    'General': '一般',
                    'Dashboards': '仪表板',
                    'Widgets': '小部件',
                    'Dashboard': '仪表板',
                    'Default': '默认',
                    'Ecommerce': '电子商务',
                    'Chart': '图表',
                    'Applications': '应用领域',
                    'Ready to use Apps': '准备使用的应用程序'
                }
            },
            ae: {
                translations: {
                    'General': 'جنرال لواء',
                    'Dashboards': 'لوحات القيادة والحاجيات',
                    'Widgets': 'لوحات القيادة',
                    'Dashboard': 'لوحة القيادة',
                    'Default': 'إفتراضي',
                    'Ecommerce': 'التجارة الإلكترونية',
                    'Chart': 'مخطط',
                    'Applications': 'التطبيقات',
                    'Ready to use Apps': 'جاهز لاستخدام التطبيقات'
                }
            },
            du: {
                translations: {
                    'General': 'Algemeen',
                    'Dashboards': 'Dashboards',
                    'Dashboard': 'Dashboard',
                    'Default': 'Standaard',
                    'Ecommerce': 'E-commerce',
                    'Widgets': 'Widgets',
                    'Chart': 'Grafiek',
                    'Applications': 'Toepassingen',
                    'Ready to use Apps': 'Klaar om apps te gebruiken'
                }
            },
        es: {
            translations: {
                'General': 'General',
                'Dashboards,Widgets': 'Cuadros de mando, widgets',
                'Dashboard': 'Tablero',
                'Default': 'Defecto',
                'Ecommerce': 'Comercio electrónico',
                'Widgets': 'Widgets',
                'Chart': 'Gráfico',
                'Applications': 'Aplicaciones',
                'Ready to use Apps': 'Gereed om programme te gebruik',
                
                'Overview': 'Visión General',
                'Process': 'Proceso',
                'Applications_menu': 'Aplicaciones',
                'Benefits': 'Beneficios',
                'Files': 'Archivos',
                'Activities': 'Actividades',
                
                'Overview_Title': 'Visión General — Proyecto Carbono Circular',
                'Creation_Date': 'Fecha de Creación',
                'Due_Date': 'Fecha de Vencimiento',
                'Priority': 'Prioridad',
                'High': 'Alta',
                'Status': 'Estado',
                'In_Progress': 'En Progreso',
                'Resource': 'Recurso',
                'Technical_Report': 'Informe Técnico "Carbon Flow — Proyecto WebFlow"',
                
                'Professors_Participants': 'Profesores y Participantes',
                
                'CO2_Title': 'Dióxido de Carbono: Energía, Clima e Innovación Sostenible',
                'CO2_Summary': 'El dióxido de carbono (CO₂) es uno de los gases más presentes en nuestro día a día — esencial para la vida, pero también protagonista de las discusiones sobre cambio climático. Comprender su ciclo, usos e impactos es el primer paso para transformar desafíos en soluciones futuras.',
                'CO2_Description1': 'Desde el sector energético hasta la industria alimentaria, el CO₂ está en todas partes: refrigeración, soldadura, bebidas, agricultura controlada e incluso en tecnologías de captura y almacenamiento que prometen redefinir la economía verde.',
                'CO2_Description2': 'Sigue los datos a continuación y descubre cómo el dióxido de carbono se comporta en volumen, emisiones y rentabilidad promedio en las principales cadenas productivas.',
                
                'AI_Prediction_Title': 'IA para Predicción de Emisiones de CO₂',
                'AI_Prediction_Description': 'Cómo la Inteligencia Artificial puede ser una herramienta poderosa para predecir emisiones de CO₂.',
                'Explore': 'Explorar',
                
                'Average_Daily_Sales': 'Promedio de Ventas Diarias',
                'Average_Daily_Sales_Value': '45,908 kg de CO₂',
                'Average_Daily_Sales_Subtitle': 'El aumento se debe a la expansión de aplicaciones industriales y mayor demanda de CO₂ líquido para refrigeración y bebidas.',
                
                'Average_Daily_Profitability': 'Rentabilidad Promedio Diaria',
                'Average_Daily_Profitability_Value': '89.6% de eficiencia energética',
                'Average_Daily_Profitability_Subtitle': 'El indicador refleja eficiencia en la conversión y reutilización del gas en procesos de captura y reutilización.',
                
                'Activity_Schedule': 'Cronograma de Actividades',
                'Industrial_Emissions_Monitoring': 'Monitoreo de emisiones industriales',
                'Workshop_New_Technologies': 'Taller: Nuevas Tecnologías de Captura de Carbono',
                
                'CO2_Emissions_Evolution': 'Evolución de Emisiones de CO₂ por Sector (Ene–Nov)',
                'Energy': 'Energía',
                'Transport': 'Transporte',
                'Industry': 'Industria',
                'CO2_Chart_Description': 'Los datos muestran estabilidad en la emisión promedio de la industria y ligera caída en el sector energético, resultado directo del aumento del uso de biogás y energía solar.',
                
                'CO2_Captured': 'CO₂ Capturado',
                'CO2_Reused': 'CO₂ Reutilizado',
                'CO2_Emitted': 'CO₂ Emitido',
                
                'CO2_Emissions_Evolution_Value': 'Evolución de Emisiones de CO₂ por Valor (Jun - Diciembre 2024)',
                
                'WAG_Process': 'Proceso WAG',
                'WAG_Process_Description': 'El proceso WAG implica la alternancia entre inyección de agua y gas para maximizar la recuperación de petróleo',
                'Water_Injection': 'Inyección de agua para mantener presión del reservorio',
                'Gas_Injection': 'Inyección de gas para mejorar la movilidad del petróleo',
                'Continuous_Monitoring': 'Monitoreo continuo de los parámetros de producción',
                'Field_Based_Optimization': 'Optimización basada en datos de campo',
                
                'WAG_Applications': 'Aplicaciones del WAG',
                'WAG_Applications_Description': 'El WAG se aplica en diversos tipos de reservorios',
                'High_Viscosity_Reservoirs': 'Reservorios de petróleo con alta viscosidad',
                'Mature_Fields': 'Campos maduros con declinio de producción',
                'Heterogeneous_Reservoirs': 'Reservorios con heterogeneidad de permeabilidad',
                'Offshore_Onshore': 'Campos offshore y onshore',
                
                'WAG_Benefits': 'Beneficios del WAG',
                'WAG_Benefits_Description': 'Principales ventajas de la técnica WAG',
                'Recovery_Increase': 'Aumento de la Recuperación',
                'Recovery_Description': 'Incremento en la recuperación de petróleo',
                'Energy_Efficiency': 'Eficiencia Energética',
                'Energy_Description': 'Reducción en el consumo de energía',
                'Cost_Benefit': 'Costo-Beneficio',
                'Cost_Description': 'Mejora en la relación costo-beneficio',
                
                'Documents_Attachments': 'Documentos y Anexos',
                'Documents_Description': 'Documentación técnica e informes relacionados con WAG',
                'Field_Reports': 'Informes de campo',
                'Laboratory_Analysis': 'Análisis de laboratorio',
                'Technical_Documentation': 'Documentación técnica',
                'Certifications_Licenses': 'Certificaciones y licencias',
                
                'Recent_Activities': 'Actividades Recientes',
                'Recent_Activities_Description': 'Últimas actividades y actualizaciones del proyecto',
                'Activities_Today': 'Actividades Hoy',
                'Completed_Tasks': 'Tareas completadas',
                'This_Week': 'Esta Semana',
                'Activities_Performed': 'Actividades realizadas',
                'Progress': 'Progreso',
                'Project_Completion': 'Conclusión del proyecto',
                
                'Content_Not_Found': 'Contenido no encontrado',
                
                'Menu_EOR': 'EOR',
                'Menu_EOR_Desc': 'Recuperación Mejorada de Petróleo',
                'Menu_WAG': 'WAG',
                'Menu_CO2_Injection': 'Inyección de CO₂',
                'Menu_HO2_Injection': 'Inyección de HO₂',
                
                'Menu_CCUS': 'CCUS',
                'Menu_CCUS_Desc': 'Captura, Utilización y Almacenamiento de Carbono',
                'Menu_CCS': 'CCS',
                'Menu_Storage_Site_Assessment': 'Evaluación del Sitio de Almacenamiento',
                'Menu_Geological_Reservoirs': 'Reservorios Geológicos',
                'Menu_Depleted_Oil_Wells': 'Pozos Agotados de Petróleo Onshore/Offshore',
                'Menu_Salt_Caverns': 'Cavernas de Sal',
                'Menu_Basalt_Others': 'Basalto y Otros',
                'Menu_Products': 'Productos',
                'Menu_Alternative_Materials': 'Materiales Alternativos',
                
                'Menu_Renewable_Energy': 'Energías Renovables',
                'Menu_Renewable_Energy_Desc': 'Fuentes de Energía Sostenibles',
                'Menu_Hydrogen': 'Hidrógeno',
                'Menu_Bioenergy': 'Bioenergía',
                'Menu_Metocean': 'Meteoceano',
                
                'Menu_Advanced_Materials': 'Materiales Avanzados',
                'Menu_Advanced_Materials_Desc': 'Tecnologías de Materiales Innovadores',
                'Menu_MOF': 'MOF (Estructuras Orgánicas-Metálicas)',
                'Menu_Solar_Cells': 'Celdas Solares',
                'Menu_Graphene_Batteries': 'Grafeno en Baterías/Membranas',
                'Menu_Nanocells': 'Nanocélulas',
                
                'Menu_Carbon_Credits': 'Créditos de Compensación de Carbono',
                'Menu_Carbon_Credits_Desc': 'Mercado de Carbono y Sostenibilidad',
                'Menu_CO2_Quantification': 'Cuantificación de CO₂',
                'Menu_Market_Analysis': 'Análisis de Mercado',
                'Menu_Nature_Preservation': 'Preservación de la Naturaleza',
                'Menu_Reforestation': 'Reforestación',
                
                'Menu_Electrification': 'Electrificación',
                'Menu_Electrification_Desc': 'Tecnologías de Generación de Energía',
                'Menu_Nuclear_Reactors': 'Reactores Nucleares',
                'Menu_Underwater_Facilities': 'Instalaciones Subacuáticas',
                
                'Profile_Articles': 'Artículos',
                'Profile_Presentations': 'Presentaciones',
                'Profile_Reviews': 'Reseñas'
            }
        },
            fr: {
                translations: {
                    'General': 'Générale',
                    'Dashboards,Widgets': 'Tableaux de bord, widgets',
                    'Dashboard': 'Tableau de bord',
                    'Default': 'Défaut',
                    'Ecommerce': 'Commerce électronique',
                    'Widgets': 'Widgets',
                    'Chart': 'Graphique',
                    'Applications': 'Applications',
                    'Ready to use Apps': `Applications prêtes à l'emploi`
                }
            },
        pt: {
            translations: {
                'General': 'Geral',
                'Dashboards,Widgets': 'Painéis, Widgets',
                'Dashboard': 'painel de controle',
                'Default': 'Padrão',
                'Ecommerce': 'Comércio eletrônico',
                'Widgets': 'Widgets',
                'Chart': 'Gráfico',
                'Applications': 'Formulários',
                'Ready to use Apps': 'Aplicativos prontos para usar',
                
                'Overview': 'Visão Geral',
                'Process': 'Processo',
                'Applications_menu': 'Aplicações',
                'Benefits': 'Benefícios',
                'Files': 'Arquivos',
                'Activities': 'Atividades',
                
                'Overview_Title': 'Visão Geral — Projeto Carbono Circular',
                'Creation_Date': 'Data de Criação',
                'Due_Date': 'Data de Prazo',
                'Priority': 'Prioridade',
                'High': 'Alta',
                'Status': 'Status',
                'In_Progress': 'Em Andamento',
                'Resource': 'Recurso',
                'Technical_Report': 'Relatório Técnico "Carbon Flow — Projeto WebFlow"',
                
                'Professors_Participants': 'Professores e Participantes',
                
                'CO2_Title': 'Gás Carbônico: Energia, Clima e Inovação Sustentável',
                'CO2_Summary': 'O dióxido de carbono (CO₂) é um dos gases mais presentes em nosso cotidiano — essencial para a vida, mas também protagonista das discussões sobre mudanças climáticas. Compreender seu ciclo, usos e impactos é o primeiro passo para transformar desafios em soluções de futuro.',
                'CO2_Description1': 'Do setor energético à indústria alimentícia, o CO₂ está em todos os lugares: refrigeração, soldagem, bebidas, agricultura controlada e até em tecnologias de captura e armazenamento que prometem redefinir a economia verde.',
                'CO2_Description2': 'Acompanhe os dados abaixo e descubra como o gás carbônico se comporta em volume, emissões e rentabilidade média nas principais cadeias produtivas.',
                
                'AI_Prediction_Title': 'IA para Predição de Emissões de CO₂',
                'AI_Prediction_Description': 'Como a Inteligência Artificial pode ser uma ferramenta poderosa para predizer emissões de CO₂.',
                'Explore': 'Explore',
                
                'Average_Daily_Sales': 'Média de Vendas Diárias',
                'Average_Daily_Sales_Value': '45,908 kg de CO₂',
                'Average_Daily_Sales_Subtitle': 'O aumento se deve à expansão das aplicações industriais e maior demanda por CO₂ líquido para refrigeração e bebidas.',
                
                'Average_Daily_Profitability': 'Rentabilidade Média Diária',
                'Average_Daily_Profitability_Value': '89.6% de aproveitamento energético',
                'Average_Daily_Profitability_Subtitle': 'O indicador reflete eficiência na conversão e reaproveitamento do gás em processos de captura e reutilização.',
                
                'Activity_Schedule': 'Cronograma de Atividades',
                'Industrial_Emissions_Monitoring': 'Monitoramento de emissões industriais',
                'Workshop_New_Technologies': 'Workshop: Novas Tecnologias de Captura de Carbono',
                
                'CO2_Emissions_Evolution': 'Evolução das Emissões de CO₂ por Setor (Jan–Nov)',
                'Energy': 'Energia',
                'Transport': 'Transporte',
                'Industry': 'Indústria',
                'CO2_Chart_Description': 'Os dados mostram estabilidade na emissão média da indústria e leve queda no setor energético, resultado direto do aumento do uso de biogás e energia solar.',
                
                'CO2_Captured': 'CO₂ Capturado',
                'CO2_Reused': 'CO₂ Reutilizado',
                'CO2_Emitted': 'CO₂ Emitido',
                
                'CO2_Emissions_Evolution_Value': 'Evolução das Emissões de CO₂ por Valor (Jun - Dezembro 2024)',
                
                'WAG_Process': 'Processo WAG',
                'WAG_Process_Description': 'O processo WAG envolve a alternância entre injeção de água e gás para maximizar a recuperação de petróleo',
                'Water_Injection': 'Injeção de água para manter pressão do reservatório',
                'Gas_Injection': 'Injeção de gás para melhorar a mobilidade do petróleo',
                'Continuous_Monitoring': 'Monitoramento contínuo dos parâmetros de produção',
                'Field_Based_Optimization': 'Otimização baseada em dados de campo',
                
                'WAG_Applications': 'Aplicações do WAG',
                'WAG_Applications_Description': 'O WAG é aplicado em diversos tipos de reservatórios',
                'High_Viscosity_Reservoirs': 'Reservatórios de petróleo com alta viscosidade',
                'Mature_Fields': 'Campos maduros com declínio de produção',
                'Heterogeneous_Reservoirs': 'Reservatórios com heterogeneidade de permeabilidade',
                'Offshore_Onshore': 'Campos offshore e onshore',
                
                'WAG_Benefits': 'Benefícios do WAG',
                'WAG_Benefits_Description': 'Principais vantagens da técnica WAG',
                'Recovery_Increase': 'Aumento da Recuperação',
                'Recovery_Description': 'Incremento na recuperação de petróleo',
                'Energy_Efficiency': 'Eficiência Energética',
                'Energy_Description': 'Redução no consumo de energia',
                'Cost_Benefit': 'Custo-Benefício',
                'Cost_Description': 'Melhoria na relação custo-benefício',
                
                'Documents_Attachments': 'Documentos e Anexos',
                'Documents_Description': 'Documentação técnica e relatórios relacionados ao WAG',
                'Field_Reports': 'Relatórios de campo',
                'Laboratory_Analysis': 'Análises de laboratório',
                'Technical_Documentation': 'Documentação técnica',
                'Certifications_Licenses': 'Certificações e licenças',
                
                'Recent_Activities': 'Atividades Recentes',
                'Recent_Activities_Description': 'Últimas atividades e atualizações do projeto',
                'Activities_Today': 'Atividades Hoje',
                'Completed_Tasks': 'Tarefas concluídas',
                'This_Week': 'Esta Semana',
                'Activities_Performed': 'Atividades realizadas',
                'Progress': 'Progresso',
                'Project_Completion': 'Conclusão do projeto',
                
                'Content_Not_Found': 'Conteúdo não encontrado',
                
                'Menu_EOR': 'EOR',
                'Menu_EOR_Desc': 'Enhanced Oil Recovery',
                'Menu_WAG': 'WAG',
                'Menu_CO2_Injection': 'Injeção de CO²',
                'Menu_HO2_Injection': 'Injeção de HO²',
                
                'Menu_CCUS': 'CCUS',
                'Menu_CCUS_Desc': 'Carbon Capture, Utilization and Storage',
                'Menu_CCS': 'CCS',
                'Menu_Storage_Site_Assessment': 'Avaliação do Local de Armazenamento',
                'Menu_Geological_Reservoirs': 'Reservatórios Geológicos',
                'Menu_Depleted_Oil_Wells': 'Poços Esgotados de Petróleo Onshore/Offshore',
                'Menu_Salt_Caverns': 'Cavernas de Sal',
                'Menu_Basalt_Others': 'Basalto e Outros',
                'Menu_Products': 'Produtos',
                'Menu_Alternative_Materials': 'Materiais Alternativos',
                
                'Menu_Renewable_Energy': 'Energias Renováveis',
                'Menu_Renewable_Energy_Desc': 'Fontes de Energia Sustentáveis',
                'Menu_Hydrogen': 'Hidrogênio',
                'Menu_Bioenergy': 'Bioenergia',
                'Menu_Metocean': 'Metoceano',
                
                'Menu_Advanced_Materials': 'Materiais Avançados',
                'Menu_Advanced_Materials_Desc': 'Tecnologias de Materiais Inovadores',
                'Menu_MOF': 'MOF (Estruturas Orgânicas-Metálicas)',
                'Menu_Solar_Cells': 'Células Solares',
                'Menu_Graphene_Batteries': 'Grafeno em Baterias/Membranas',
                'Menu_Nanocells': 'Nanocélulas',
                
                'Menu_Carbon_Credits': 'Créditos de Compensação de Carbono',
                'Menu_Carbon_Credits_Desc': 'Mercado de Carbono e Sustentabilidade',
                'Menu_CO2_Quantification': 'Quantificação de CO²',
                'Menu_Market_Analysis': 'Análise de Mercado',
                'Menu_Nature_Preservation': 'Preservação da Natureza',
                'Menu_Reforestation': 'Reflorestamento',
                
                'Menu_Electrification': 'Eletrificação',
                'Menu_Electrification_Desc': 'Tecnologias de Geração de Energia',
                'Menu_Nuclear_Reactors': 'Reatores Nucleares',
                'Menu_Underwater_Facilities': 'Instalações Subaquáticas',
                
                'Profile_Articles': 'Artigos',
                'Profile_Presentations': 'Apresentações',
                'Profile_Reviews': 'Avaliações'
            }
        }
        },
        fallbackLng: 'pt',
        debug: false,

        ns: ['translations'],
        defaultNS: 'translations',

        keySeparator: false, 

        interpolation: {escapeValue: false}
    });

export default i18n;
